import { Action as ReduxAction } from 'redux';

import { User } from '../../types/api/user';

export enum ActionType {
  SetUser = 'Me/SetUser',
  RunOnboarding = 'Me/RunOnboarding',
  StopOnboarding = 'Me/StopOnboarding',
  OnboardingNextStep = 'Me/OnboardingNextStep',
  OnboardingPrevStep = 'Me/OnboardingPrevStep',
  SetOnboardingStep = 'Me/SetOnboardingStep',
  SetRedirectRoute = 'Me/SetRedirectRoute',
}

export interface Action extends ReduxAction<ActionType> {
  user?: User;
  onboardingName?: onboardingName;
  stepIndex?: number;
  setStep?: { stepIndex: number; onboardingName: onboardingName; };
  redirectAfterAuth?: string;
}

export type onboardingName = 'createOrder';

export interface OnboardingItem {
  name: onboardingName;
  isRunning: boolean;
  stepIndex: number;
}

export interface State {
  user: null | User;
  redirectAfterAuth: string;
  onboardings: OnboardingItem[];
}
